import { SettingsService } from '../../../services/settings-service';
import UserCentricViewController from '../usercentrics-view-controller';
import { GetConsentsService } from '../../../services/consents-services/get-consents.service';
import { DataService } from '../../../services/utilities/data.service';
import { Consent } from '../../../dataTypes/type-consent';
import { UtilityService } from '../../../services/utility.service';
const bannerModalTemplate1 = require('./templates/banner-template-1.hbs');
const bannerModalTemplate12 = require('./templates/banner-template-12.hbs');
const bannerModalTemplateTCF = require('./templates/banner-template-tcf.hbs');
const centralBanner = require('../../../../components/templates/banner/centered/banner-centered.hbs');

const _ = require('lodash');
const acceptBtnId = 'uc-btn-accept-banner';
const continueBtnId = 'uc-btn-more-info-banner';
const declineBtnId = 'uc-btn-deny-banner';
const mobileReadMoreBtnId = 'uc-optin-read-more';
const overlayClassName = 'inactive-background';
const saveBtnId = 'uc-btn-save-banner';

export default class BannerViewController {
    public purposeStatus: IAB.PurposeStatus = {};
    public featureStatus: IAB.PurposeStatus = {};
    private isReadMoreClicked: boolean;
    private selectionStatus = {
        allSelected: false,
        allUnselected: true
    }
    private settingsService: SettingsService;
    private utilityService: UtilityService;
    private updateView: any;
    private banner12SpecialStyle = {
        display: 'hidden',
        left: 'auto',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: 'auto',
        height: 'auto'
    };

    constructor(mainViewContoller, updateView, utilityService) {
        this.savePurposeChoice = this.savePurposeChoice.bind(this);
        this.settingsService = utilityService.settingsService;
        this.updateView = updateView;
        this.utilityService = utilityService;
        this.initializePurposeStatus();
    }

    public initializePurposeStatus(): void {
        this.purposeStatus = this.utilityService.cmpIABService.getIabPurposeStatus();
        this.featureStatus = this.utilityService.cmpIABService.getFeatureStatus();
        this.updateAllStatus(this.purposeStatus, this.featureStatus);
    }

    public updatePurposeStatus(purposeStatus: IAB.PurposeStatus): void {
        this.purposeStatus = JSON.parse(JSON.stringify(purposeStatus));
    }

    private registerCollectionSelectionEvent(list: any[], elementSelector: string, identifier: string): void {
        if (list) {
            list.forEach((item, index) => {
                const checkboxElement = document.getElementById(`${elementSelector}${item.id}`);
                if (checkboxElement) {
                    checkboxElement.onclick = () => {
                        this[identifier][list[index].id] = !this[identifier][list[index].id];
                        this.updateAllStatus(this.purposeStatus, this.featureStatus);
                        this.updateView();
                    };
                }
            });
        }
    }

    private updateAllStatus(purposeStatus: IAB.PurposeStatus, featureStatus: IAB.PurposeStatus): void {
        const purposesSelected = Object.keys(purposeStatus).filter((item: string) => purposeStatus[item]).length;
        const featuresSelected = Object.keys(featureStatus).filter((item: string) => featureStatus[item]).length;

        const countSelected: number = purposesSelected + featuresSelected;
        const countTotal: number = this.utilityService.cmpIABService.purposes.length + this.utilityService.cmpIABService.features.length;
        this.selectionStatus.allSelected = (countSelected === countTotal);
        this.selectionStatus.allUnselected = (countSelected === 0);
    }

    setBanner12SpecialSvg(rect) {
        // set position of fingerprint icon in banner-modal overlay
        this.banner12SpecialStyle.left = rect.left + 'px';
        this.banner12SpecialStyle.top = rect.top + 'px';
        this.banner12SpecialStyle.right = rect.right + 'px';
        this.banner12SpecialStyle.bottom = rect.bottom + 'px';
        this.banner12SpecialStyle.width = rect.right - rect.left + 'px';
        this.banner12SpecialStyle.height = rect.bottom - rect.top + 'px';
        this.banner12SpecialStyle.display = 'block';
    }

    private getViewHTML(useIabTemplate): any {
        if (useIabTemplate) {
            return bannerModalTemplateTCF;
        }
        const layoutParams: any = this.getPreparedLayoutParams();
        switch (layoutParams.view) {
            case 'banner-modal-template-1':
            case 'banner-modal-template-8':
            case 'banner-modal-template-11':
                return bannerModalTemplate1;
            case 'banner-modal-template-12':
            default:
                return bannerModalTemplate12;
                break;
        }
    }

    private getBackgroundData() {
        if (this.utilityService.bgOverlayService) {
            return this.utilityService.bgOverlayService.getOverlayProperty('Banner');
        }

        return {
            darken: 0,
            overlayBackground: false,
            clickToClose: false,
        };
    }

    private getOptinText(optInConsent: Consent.Consent) {
        if (!optInConsent) {
            return '';
        }

        if (optInConsent.description && optInConsent.description.length) {
            return optInConsent.description.replace(/(\r\n|\n|\r)/gm, '<br>');
        }

        return DataService.consentTemplates[optInConsent.templateId][optInConsent.version].description.replace(
            /(\r\n|\n|\r)/gm,
            '<br>'
        );
    }

    private getHtml() {
        const backgroundData = this.getBackgroundData();
        const settings = this.settingsService.settings;
        const elementsVisibility = this.settingsService.elementsVisibility;
        const optInConsent: Consent.Consent = GetConsentsService.getOptinConsent();
        const optinText = this.getOptinText(optInConsent);
        const useIabTemplate: boolean = this.utilityService.useIabTemplate();
        if (this.settingsService.settings.firstUserInteraction === 1 || useIabTemplate) {
            return this.getViewHTML(useIabTemplate)({
                settings: this.settingsService.settings,
                bannerBgColor: settings.styles.bannerBgColor,
                bgData: backgroundData,
                features: this.utilityService.cmpIABService.features,
                featureStatus: this.featureStatus,
                purposes: this.utilityService.cmpIABService.purposes,
                purposeStatus: this.purposeStatus,
                icons: UserCentricViewController.icons,
                optInConsent: optInConsent,
                consentTemplates: DataService.consentTemplates,
                elementsVisibility: this.settingsService.elementsVisibility,
                banner12SpecialStyle: this.banner12SpecialStyle,
                isBtnDeny: elementsVisibility.showDeny,
                btnDenyClass: 'deny',
                btnDenyTextColor: settings.styles.btnDenyTextColor,
                btnDenyBgColor: settings.styles.btnDenyBgColor,
                btnDenyModifier: null,
                btnDenyText: settings.labels.btnDeny,
                optinMsgColor: settings.styles.txtOptInMsgColor,
                showAcceptAll: this.selectionStatus.allSelected || this.selectionStatus.allUnselected,
                showSaveSelected: !this.selectionStatus.allSelected && !this.selectionStatus.allUnselected
            });
        }
        return centralBanner({
            bannerBgColor: settings.styles.bannerBgColor,
            bannerMobileDescription: settings.bannerMobileDescription,
            bannerMobileDescriptionIsActive: settings.bannerMobileDescriptionIsActive,
            btnAcceptBgColor: settings.styles.btnAcceptBgColor,
            btnAcceptClass: 'accept',
            btnAcceptModifier: null,
            btnAcceptText: settings.labels.btnAccept,
            btnAcceptTextColor: settings.styles.btnAcceptTextColor,
            btnBannerReadMore: settings.labels.btnBannerReadMore,
            btnDenyBgColor: settings.styles.btnDenyBgColor,
            btnDenyClass: 'deny',
            btnDenyModifier: null,
            btnDenyText: settings.labels.btnDeny,
            btnDenyTextColor: settings.styles.btnDenyTextColor,
            btnMoreBgColor: settings.styles.btnMoreInfoBgColor,
            btnMoreClass: 'more',
            btnMoreModifier: null,
            btnMoreText: settings.labels.btnMore,
            btnMoreTextColor: settings.styles.btnMoreInfoTextColor,
            headingText: null,
            isBtnAccept: true,
            isBtnDeny: elementsVisibility.showDeny,
            isBtnMore: elementsVisibility.showMore,
            isOverlay: backgroundData.overlayBackground,
            isPoweredBy: elementsVisibility.poweredBy,
            optinMsgColor: settings.styles.txtOptInMsgColor,
            optinMsgFontSize: settings.styles.txtOptInMsgFontSize,
            optinText: optinText,
            overlayDarken: backgroundData.darken,
            settings: settings,
        });
    }

    private getPreparedLayoutParams() {
        const layouts = SettingsService.layouts;
        const goalLayout = _.find(layouts, {
            name: this.settingsService.settings.layout,
        });
        return {
            view: goalLayout.bannerModalView,
        };
    }

    private saveService(actionBtnId, callback) {
        const actionBtn = document.getElementById(actionBtnId);
        if (actionBtn) {
            actionBtn.onclick = () => {
                this.visible = false;
                this.utilityService.developmentLog('Accept clicked');
                const bannerElement = document.getElementById('uc-banner-modal') || document.getElementById('uc-central-banner-modal');

                if (bannerElement) {
                    bannerElement.innerHTML = '';
                    this.utilityService.developmentLog('banner hid first');
                }

                setTimeout(() => {
                    this.settingsService.saveFirstUserInteraction();
                    callback();
                    this.updateView();
                }, 0);
            };
        }
    }

    private updateAllPurposesStatus(newStatus: boolean): void {
        this.utilityService.cmpIABService.purposes.forEach((purpose: IAB.Purpose) => this.purposeStatus[purpose.id] = newStatus );
        this.utilityService.cmpIABService.features.forEach((feature: IAB.Feature) => this.featureStatus[feature.id] = newStatus );
    }

    private savePurposeChoice(buttonId: string): void {
        if (buttonId === declineBtnId) {
            this.updateAllPurposesStatus(false);
        } else if (buttonId === saveBtnId && this.selectionStatus.allUnselected) {
            this.updateAllPurposesStatus(true);
        }
        DataService.storeToLocalStorage('features', this.featureStatus);
        DataService.storeToLocalStorage(this.utilityService.cmpIABService.NON_IAB_PURPOSE_STORAGE_KEY, this.purposeStatus[this.utilityService.cmpIABService.DEFAULT_NON_IAB_PURPOSE.id]);
        this.utilityService.cmpIABService.updateControllerPurposeStaus(this.purposeStatus);
        this.utilityService.saveConsentsService.updateConsentsFromPurposes();
    }

    public initHandling() {
        const useIabTemplate: boolean = this.utilityService.useIabTemplate();
        const modalWrapperElement = document.getElementById('uc-banner-modal');

        if (this.visible) {
            if (useIabTemplate) {
                this.saveService(declineBtnId, () => { this.savePurposeChoice(declineBtnId); });
                this.saveService(saveBtnId, () => { this.savePurposeChoice(saveBtnId); });
            } else {
                this.saveService(declineBtnId, () => { this.settingsService.denyAllCookiesExceptEssential() });
                this.saveService(acceptBtnId, () => { this.settingsService.acceptCookiesAgreement() });
            }
            const moreBtn = document.getElementById(continueBtnId);
            if (moreBtn) {
                moreBtn.onclick = () => {
                    this.utilityService.moreInfoEventsService.initMoreInfoEvent();
                    this.visible = true;
                    this.updateView();
                };
            }

            // setOriginalDescriptionInView if read more was already clicked before or bannerMobileDescriptionIsActive is disabled.
            if (this.isReadMoreClicked || !this.settingsService.settings.bannerMobileDescriptionIsActive) {
                BannerViewController.setOriginalDescriptionInView();
            } else {
                // get mobileReadMoreBtn only if readMore btn is visible to DOM.
                const mobileReadMoreBtn = document.getElementById(mobileReadMoreBtnId);
                // add click listener to mobileReadMoreBtn only If bannerMobileDescriptionIsActive is enabled
                if (mobileReadMoreBtn && this.settingsService.settings.bannerMobileDescriptionIsActive) {
                    mobileReadMoreBtn.onclick = () => {
                        this.isReadMoreClicked = true;
                        BannerViewController.setOriginalDescriptionInView();
                    };
                }
            }
            const overlays = modalWrapperElement ? modalWrapperElement.getElementsByClassName(
                overlayClassName
            ) : [];
            _.forEach(overlays, closeBtn => {
                if (closeBtn) {
                    let bgData = {
                        darken: 0,
                        overlayBackground: false,
                        clickToClose: false,
                    };
                    if (this.utilityService.bgOverlayService) {
                        bgData = this.utilityService.bgOverlayService.getOverlayProperty(
                            'Banner'
                        );
                    }
                    if (bgData.clickToClose) {
                        closeBtn.onclick = (event: any) => {
                            this.visible = false;
                            this.updateView();
                        };
                    }
                }
            });
            if (this.banner12SpecialStyle.display === 'block') {
                var pasteDiv = document.getElementById('uc-fingerprint-icon-overlay');
                if (pasteDiv) {
                    pasteDiv.onclick = () => {
                        window.usercentrics.toggleCornerModalIsVisible();
                    };
                }
            }
            this.registerCollectionSelectionEvent(this.utilityService.cmpIABService.purposes, 'toggle-consent-', 'purposeStatus');
            this.registerCollectionSelectionEvent(this.utilityService.cmpIABService.features, 'toggle-features-', 'featureStatus');
        }
    }

    /**
     * replace small(mobile) description with detailed(original) description by chnaging display of dom element
     */
    static setOriginalDescriptionInView() {
        const smallDescription = document.getElementById('uc-small-optin-description');
        const detailedDescription = document.getElementById('uc-full-optin-description');
        if (smallDescription) {
            smallDescription.style.display = 'none';
        }
        if (detailedDescription) {
            detailedDescription.style.display = 'inline';
        }
    }

    public set visible(_isVisible: boolean) {
        this.settingsService.bannerIsVisible = _isVisible;
    }

    public get visible() {
        return this.settingsService.elementsVisibility.bannerVisible;
    }

    public get htmlString() {
        if (this.visible) {
            return this.getHtml();
        }
        return '';
    }
}